import React , {Component} from "react"
import Asset4 from "../../assets/Client/03.png"
import Mobile from "../../assets/Client/Groupe 79.png"
import './styles.css'
import QuoteIMG from '../../assets/Client/,,.png'
import MobileIcon from '../../assets/Client/Groupe 70.png'
import WorkIcon from '../../assets/Client/Groupe 69.png'
import SearchIcon from '../../assets/Client/Groupe 68.png'
import Avatar from '../../assets/Client/Ellipse 14.svg'
import {RanaLahna} from "../Others/RanaLahnaComponent/RanaLahnaComponent";
import {Helmet} from "react-helmet";
import FavIcon from "../../assets/FavIcons/03.ico";

const CardClientPage=({icon , title , content })=>{
    return(
        <div className="col-12 col-lg-4 mt-5 mb-5 mt-lg-0 mb-lg-0">
            <div className="d-flex justify-content-center">
                {/*<i  style={{ padding : '0.6rem' , fontSize : '2rem' , borderRadius : '100%' , border : '2px solid var(--primary-adsil-color)'}} className={icon +" primary-adsil-color"}></i>*/}
                <img style={{ width : '92px' , height : '92px'}} src={icon} alt=""/>
            </div>
            <div className="pt-2 pb-2 cardClientTitle">{title}</div>
            <div className="cardClientContent pl-lg-5 pr-lg-5" style={{textAlign : 'center' }}>{content}</div>
        </div>
    )
}
const Quote =({ quote , author , typeUser})=>{
    return(
        <div className='quote p-3'>
                <img src={QuoteIMG} alt=""/>
                <div className=" p-lg-0  pt-lg-3 pb-lg-5 mb-lg-5 quoteContent ">
                    {quote}
                </div>
                <div  className="d-lg-flex quoteAuthor mt-3 mt-lg-0" >
                    <img className="mr-3 quoteAuthorImg"  src={Avatar} alt=""/>
                    <div className="quoteAuthorDetails"  style={{ display: 'flex' , flexDirection: 'column' , justifyContent: 'center'  }}>
                        <div>{author}</div>
                        <div>{typeUser}</div>
                    </div>
                </div>

        </div>
    )

}
// import MobileIcon from 'material-ui-community-icons/icons/cellphone'
export class Client extends Component{
    constructor(props) {
        super(props);
    }
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title> ADSIL Client</title>
                    <link rel="shortcut icon"  href={FavIcon} />
                </Helmet>
                <div className="col-12 text-black"  id="clientSec1" style={{paddingTop : '2rem'}}>
                    <div className="d-flex justify-content-center mt-4 mb-4">
                        <img style={{height : '5rem'}} src={Asset4} alt=""/>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        <h2 className="pt-1 d-inline" style={{textAlign : 'center' , borderBottom : "5px solid var(--primary-adsil-color)" , fontWeight : 'bold'}}> VOYAGEURS </h2>
                    </div>
                    <div className="row mr-0 ml-0 justify-content-center">
                        <div className="col-10 voyageursHighLight" >
                            Adsil est une plateforme de réservation de taxis collectifs inter-wilayas. Elle permet d’améliorer considérablement les voyages des utilisateurs qui peuvent réserver à distance et à l’avance une ou plusieurs places, selon le besoin, et de choisir les heures et le lieu de départ.
                        </div>
                    </div>
                    <div className="row mr-0 ml-0 mt-4 justify-content-center">
                        <img  id="voyageursImg"  src={Mobile} alt=""/>
                    </div>
                </div>
                <div className="col-12"  id="clientSec2" style={{padding : 0}}>
                    <div className="mt-3 offset-1 voyageursHighLight col-10">
                        Nous avons créé ADSIL autour de la conviction que lorsque les gens sont bien traités, ils fournissent un meilleur service
                    </div>
                    <div className="d-lg-flex pr-4 pl-4 mt-lg-5 mb-lg-5">
                        <CardClientPage title={'En toute sécurité:'} icon={MobileIcon} content={'Que vous soyez seul ou accompagné, votre chauffeur est certifié et notre Call Center est joignable 24h/7'} />
                        <CardClientPage title={'Au meilleurs prix'} icon={WorkIcon} content={'la réservation se fait par place et en quelques clics seulement.'} />
                        <CardClientPage title={'Sans avoir à attendre votre tour.'} icon={SearchIcon} content={'Pour être au plus près de vous, nous vous proposons des points de ramassages et de dépôts dans plusieurs communes de chaque wilaya, ainsi que la possibilité de vous récupérer à domicile  selon le besoin.'} />
                    </div>
                    <div className="pb-4 pl-4 pr-4" id="quotes" style={{backgroundColor : '#F5F5F5' }}>
                        <Quote typeUser={'utilisateur'} author={'Brandon Matthews'} quote={'For a start, the app is actually pretty good, and work perfectly.  The layout is easy to understand, and the commands are simple, and as a developer, all I can say is I wish all the best and success for you guys, you\'re already in the right path 🙏.'}/>
                        <Quote typeUser={'utilisatrice'} author={'Elizabeth Murphy'} quote={'Très bonne prestation service parfait et ponctuelle lors de la réception du paiement . merci et bonne continuation.'}/>
                        <Quote typeUser={'utilisatrice'} author={'Rami Tamrabet'} quote={'Un excellent service qui aidera beaucoup de voyageurs et de taxieurs sur le territoire national'}/>
                        <Quote typeUser={'utilisateur'} author={'Frank Gilbert'} quote={'Très bon concept. L\'application est très simple à utiliser et le service clientèle est au TOP. Une prise en charge rapide et professionnelle .mon voyage était très satisfaisant.'}/>
                    </div>
                </div>
                <RanaLahna titleBlue={'سافر متهني'} titleGray={'Notre call center est à votre écoute ! '} contentGray={'Contactez-nous au 0982441442'}/>


                {/*<div id="clientSec2">*/}
                {/*    /!*<div id="titleClientSec2">*!/*/}
                {/*    /!*    Nous avons créé ADSIL autour de la conviction que lorsque les gens sont bien traités , ils fournissent un bien service*!/*/}
                {/*    /!*</div>*!/*/}
                {/*</div>*/}
            </React.Fragment>
        )
    }
}